import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

export type ExportNoteTone = 'info' | 'muted' | 'warning';

const toneClasses: Record<ExportNoteTone, string> = {
    info: 'alert-web-blue',
    muted: 'alert-secondary',
    warning: 'alert-warning',
};

@Component({
    selector: 'app-export-note',
    standalone: true,
    template: `
        <div
            class="alert d-flex align-items-start gap-2 mb-0 py-2 px-3 small"
            [class]="toneClass()"
            role="note">
            <i class="bi flex-shrink-0" [class]="icon()" aria-hidden="true"></i>
            <div><ng-content /></div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportNoteComponent {
    readonly icon = input.required<string>();
    readonly tone = input<ExportNoteTone>('info');

    protected readonly toneClass = computed(() => toneClasses[this.tone()]);
}
